<div class="assessment-console m-auto bg-white rounded shadow-sm-darker">
  <div class="tab-btns-wrap d-flex flex-column flex-sm-row">
    <button class="tab-btn border-0 px-1 py-3 p-sm-0" (click)="viewfilter(FILTER_ALL, $event)"
      [ngClass]="{'tab-btn--active': filter === FILTER_ALL}"><span class="mr-2">All</span><span
        class="badge badge-success">{{assessmentList.length}}</span></button>
    <button class="tab-btn border-0 px-1 py-3 p-sm-0" (click)="viewfilter(FILTER_TIMED, $event)"
      [ngClass]="{'tab-btn--active': filter === FILTER_TIMED}"><span class="mr-2">Timed</span><span
        class="badge badge-warning ">{{timedCount}}</span></button>
    <button class="tab-btn border-0 px-1 py-3 p-sm-0" (click)="viewfilter(FILTER_SCORED, $event)" *ngIf="!isadmin"
      [ngClass]="{'tab-btn--active': filter === FILTER_SCORED}"><span class="mr-2">Scored</span><span
        class="badge badge-info">{{scoredCount}}</span></button>
    <button (click)="viewfilter(FILTER_ANSWERED, $event)" *ngIf="!isadmin" class="tab-btn border-0 px-1 py-3 p-sm-0"
      [ngClass]="{'tab-btn--active': filter === FILTER_ANSWERED}"><span class="mr-2">Submitted</span><span
        class="badge badge-success">{{submittedCount}}</span></button>
  </div>
  <div class="p-4">
    <div class="row">
      <div class="mr-2">

        <div *ngIf="isBatched && isadmin">
          <label>Batch:</label>
          <select class="p-2 m-1" (change)="sortByBatch(FilterByBatchText)" [(ngModel)]="FilterByBatchText"
            name="FilterByBatchText">
            <option *ngFor="let batch of moduleBatches" [ngValue]="batch.id">
              {{batch.name}}
            </option>
          </select>
        </div>
      </div>
    </div>
    <button *ngIf="showCreateNewAssesmentwidget && isadmin" routerLink="/user/newassessment"
      [queryParams]="{ classid: this.currentClassID }" class="btn mx-auto">
      <i class="fa fa-plus"></i> Create Assessment
    </button>
    <p *ngIf="showCreateNewAssesmentwidget && !isadmin" class="text-sm text-center font-italic mb-0">There Are No
      Assessments Available</p>
    <p *ngIf="!showCreateNewAssesmentwidget && filteredAssessmentList.length < 1"
      class="text-sm text-center font-italic mb-0">There Are No Assessments Available In This Filter</p>
    <ul class="list-group list-group-flush">
      <li class="list-group-item px-0" *ngFor="let assessment of filteredAssessmentList">
        <button *ngIf="assessment.answered || !assessment.istimed"
          (click)="openAssessment(assessment.id,assessment.batchid)"
          class="d-block w-100 group-link p-0 m-0 border-0 bg-transparent text-left">
          <h3 class="text-sm font-weight-500 text-primary-darker mb-0">{{assessment.name}}</h3>
          <p class="text-xs m-0">
            <span class="font-weight-500">Start: </span><time>{{assessment.starttime}}</time>
            <br>
            <span class="font-weight-500">Due: </span><time>{{assessment.duedate}}</time>
            <br>
            <span *ngIf="assessment.istimed" class="mt-2 mr-2 badge badge-lg badge-success"><i
                class="ni ni-time-alarm"></i> Timed Assessment</span>
            <span *ngIf="assessment.answered" class="mt-2 mr-2 badge badge-lg badge-success">Submitted</span>
            <span *ngIf="!assessment.answered && !this.isadmin"
              class="mt-2 mr-2 badge badge-lg badge-warning">Pending</span>
            <span *ngIf="assessment.optional" class="mt-2 mr-2 badge badge-lg badge-info">Optional</span>
            <span *ngIf="assessment.scored" class="mt-2 mr-2 badge badge-lg badge-info">
              Scored : {{assessment.score}} </span>
          </p>
        </button>
        <button *ngIf="assessment.istimed && this.isadmin"
          (click)="openAssessment(assessment.id,assessment.batchid)"
          class="d-block w-100 group-link p-0 m-0 border-0 bg-transparent text-left">
          <h3 class="text-sm font-weight-500 text-primary-darker mb-0">{{assessment.name}}</h3>
          <p class="text-xs m-0">
            <span class="font-weight-500">Start: </span><time>{{assessment.starttime}}</time>
            <br>
            <span class="font-weight-500">Due: </span><time>{{assessment.duedate}}</time>
            <br>
            <span class="font-weight-500">Duration: </span>{{assessment.duration}} {{assessment.duration == 1 ? "minute"
            : "minutes"}}
            <br />
            <span class="mt-2 badge badge-lg badge-info"><i class="ni ni-time-alarm"></i> Timed
              Assessment</span>
            <span *ngIf="assessment.optional" class="mt-2 mr-2 badge badge-lg badge-info">Optional</span>
          </p>
        </button>
        <button *ngIf="!assessment.answered && assessment.istimed && !this.isadmin"
          (click)="setModalInvokeParam(assessment.id,assessment.sessionactive,assessment.batchid)"
          data-toggle="modal" class="d-block w-100 group-link p-0 m-0 border-0 bg-transparent text-left">
          <h3 class="text-sm font-weight-500 text-primary-darker mb-0">{{assessment.name}}</h3>
          <p class="text-xs m-0">
            <span class="font-weight-500">Start: </span><time>{{assessment.starttime}}</time>
            <br>
            <span class="font-weight-500">Due: </span><time>{{assessment.duedate}}</time>
            <br>
            <span class="font-weight-500">Duration: </span>{{assessment.duration}} {{assessment.duration == 1 ? "minute"
            : "minutes"}}
            <br />
            <span class="mt-2 mr-2 badge badge-lg badge-warning"><i class="ni ni-time-alarm"></i>
              Timed Assessment</span>
            <span *ngIf="assessment.answered" class="mt-2 mr-2 badge badge-lg badge-success">
              Submitted </span>
            <span *ngIf="!assessment.answered && !this.isadmin" class="mt-2 mr-2 badge badge-lg badge-warning">
              Pending </span>
            <span *ngIf="assessment.optional" class="mt-2 mr-2 badge badge-lg badge-info">Optional</span>
            <span *ngIf="assessment.scored" class="mt-2 mr-2 badge badge-lg badge-info">
              Scored : {{assessment.score}} </span>
            <span *ngIf="assessment.sessionactive" class="mt-2 mr-2 badge badge-lg badge-danger">
              Currently Running!!!</span>
          </p>
        </button>
      </li>
    </ul>
  </div>
</div>

<div class="modal fade" id="tmamodal" tabindex="1" data-backdrop="static" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <h3 class="modal-title text-danger mb-0">Warning!</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="mb-0 text-center"> You are about to open a <span class="font-weight-600 text-danger">TIMED
            ASSESSMENT</span>.<br>
          Please, ensure that you are prepared to start this assessment.<br>
          Once started, the <span class="font-weight-600 text-danger">TIMER BEGINS TO COUNTDOWN</span>.<br>
        </p>
      </div>
      <div class="modal-footer justify-content-center gap-1.5">
        <span data-dismiss="modal" id="closeModal" hidden></span>
        <input class="btn btn--danger m-0" type="button" data-dismiss="modal"
          (click)="openAssessment(ModalInvokerTimedAssessment,ModalInvokerTimedAssessmentBatch)" value="Start">
        <input class="btn m-0" type="button" id="clear-options" data-dismiss="modal" value="Cancel">
      </div>
    </div>
  </div>
</div>
